export default __webpack_public_path__ + "static/media/email.42f22e42.svg";